import React from 'react';
import { readable } from './api';
export function Field({ label, children, hint, ...input }) {
  return (
    <label className="msg-field">
      <span>{label}</span>
      {children || <input {...input} />}
      {hint && <small>{hint}</small>}
    </label>
  );
}
export function Status({ value }) {
  return <span className={'msg-status msg-status-' + value}>{readable(value)}</span>;
}
